import React from 'react'

import Exclamation from 'components/CommonUI/svgIcons/Exclamation'
import { routingConstants } from 'constants/routingConstants'
import { useShallowEqualSelector } from 'custom-hooks'
import { getIsNewAlertsSelector } from 'redux/reducers/alerts'
import { Tooltip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const AlertItem = () => {
  const isReadAlerts = useShallowEqualSelector(getIsNewAlertsSelector)

  const history = useHistory()
  const handleClick = () => {
    history.push(routingConstants.alert)
  }

    return (
        <div className="header_alert_link"
             onClick={handleClick}
        >
            <Tooltip arrow placement="top" title={<span style={{ fontSize: '13px' }}>Alerts</span>}>
             <span>
              {isReadAlerts && <span className="badge_of_new_alerts"/>}
                 <Exclamation/>
             </span>
            </Tooltip>
        </div>
    )
}

export default AlertItem
